import { TOCSLIDER} from './TocSliderTypes'

const initialState = {
    nodes: {
        name: "",
        oggetto: "",
        visible: false,
        opacity: 1
    }
}

const tocSlider = (state = initialState, action) => {
    
    switch (action.type) {
        case TOCSLIDER:
            
            return {
                nodes: action.load
            }
    
        default:
          return state
    }

}

export default tocSlider;
